export const officeDetailsColumnSx = {
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  gap: "0.25rem",
};

export const reviewsRowSx = {
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
};

export const starsRowSx = {
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
};

export const officeButtonsRowSx = {
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
  flexWrap: "nowrap",
  overflowX: "auto",
  whiteSpace: "nowrap",
  position: "relative",
  "&::-webkit-scrollbar": {
    display: "none",
  },
};
